import { z } from "zod";
import type { ContactEventType, ContactGuestRange } from "./schemas";

/**
 * Teklif talepleri (landing formu) + teklif formu hunisi — migration 052.
 * CHECK listeleri `migrations/052_contact_requests.sql` ile birebir
 * (`__tests__/leads.test.ts` dosyadan okuyup doğrular).
 */

/** Satış durumu: yeni → arandı → kazanıldı / kaybedildi. */
export const CONTACT_REQUEST_STATUSES = ["new", "contacted", "won", "lost"] as const;
export type ContactRequestStatus = (typeof CONTACT_REQUEST_STATUSES)[number];

/**
 * Huni adımları: formu gördü → 1. adımla etkileşti → iletişim adımına geçti →
 * gönderdi. `submit` yalnız SUNUCUDA sayılır (başarılı kayıtta); istemci
 * ilk üçünü bildirir.
 */
export const FUNNEL_STEPS = ["view", "step1", "step2", "submit"] as const;
export type FunnelStep = (typeof FUNNEL_STEPS)[number];
export const CLIENT_FUNNEL_STEPS = ["view", "step1", "step2"] as const;
export type ClientFunnelStep = (typeof CLIENT_FUNNEL_STEPS)[number];

export const funnelEventSchema = z.object({ step: z.enum(CLIENT_FUNNEL_STEPS) });

/** KVKK saklama süresi — günlük cron bundan eski talepleri siler. */
export const CONTACT_REQUEST_RETENTION_MONTHS = 24;

export const contactRequestPatchSchema = z
  .object({
    status: z.enum(CONTACT_REQUEST_STATUSES).optional(),
    adminNote: z.string().trim().max(1000).optional(),
  })
  .refine((v) => v.status !== undefined || v.adminNote !== undefined, { message: "empty_patch" });
export type ContactRequestPatch = z.infer<typeof contactRequestPatchSchema>;

/** Admin listesindeki satır (`GET /api/admin/contact-requests`). */
export interface ContactRequestRow {
  id: string;
  created_at: string;
  updated_at: string;
  name: string;
  email: string;
  phone: string;
  event_type: ContactEventType;
  event_date: string;
  guest_range: ContactGuestRange;
  /** Formda seçilen paket (2026-10-16'dan beri misafir sayısı bununla sorulur); `custom` = en büyük paketten kalabalık. */
  plan: "free" | "pro" | "max" | "custom" | null;
  city: string;
  message: string;
  lang: string;
  estimate_try: number | null;
  estimate_from: number;
  email_sent: number;
  status: ContactRequestStatus;
  admin_note: string;
}

export interface FunnelDay {
  day: string;
  view: number;
  step1: number;
  step2: number;
  submit: number;
}
